import { render, staticRenderFns } from "./StudentAllSentencesPage.vue?vue&type=template&id=7b5b87ca&lang=pug&"
import script from "./StudentAllSentencesPage.vue?vue&type=script&lang=js&"
export * from "./StudentAllSentencesPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentAllSentencesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports